import orderBy from "lodash/orderBy";

export const getCodesAlphabetically = (usablePto) => {
  return orderBy(Object.keys(usablePto), [(code) => code], ["asc"]);
};

export const getColorMap = (usablePTO) => {
  let colorMap = {
    usable: "dark",
    pending: "grey",
    scheduled: "light",
    editing: "green",
  };

  if (usablePTO < 0) {
    colorMap = {
      pending: "grey",
      scheduled: "light",
      editing: "red",
    };
  }

  return colorMap;
};

export const updateScheduledPTO = (scheduledPTO, completedPTO) => {
  if (completedPTO === 0) {
    return scheduledPTO;
  }

  return scheduledPTO - completedPTO;
};
